import { render, staticRenderFns } from "./deliveryChargeReports.vue?vue&type=template&id=39869a3f&scoped=true"
import script from "./deliveryChargeReports.vue?vue&type=script&lang=js"
export * from "./deliveryChargeReports.vue?vue&type=script&lang=js"
import style0 from "./deliveryChargeReports.vue?vue&type=style&index=0&id=39869a3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39869a3f",
  null
  
)

export default component.exports